import { RepositoryFactory } from './../../repositories/RepositoryFactory.js';

const customerRepository = RepositoryFactory.get('customerAdmin');

export default async function auth({ to, next }) {
    const loginQuery = { path: "/login", query: { redirect: to.fullPath } };
    const customer = await customerRepository.getCustomerAuth();
    if (!customer.data.customer) {
        return next(loginQuery);
    }
    next();
}   
